import type { PropType } from 'vue';
import type { Component } from '~/types';
import { IconsConstants } from '~/composables/icons.constants';
import { useWebsiteStore } from '~/units/website/store';

export const ComponentMixin = defineNuxtComponent({
  props: {
    component: {
      required: true,
      type: Object as PropType<Component>,
    },
  },

  data() {
    return {
      icons: IconsConstants,
    };
  },

  computed: {
    vars(): { [key: string]: string | number | null } {
      const variables = this.component.variables;

      if (variables) {
        const vars: { [key: string]: string | number | null } = {};
        Object.keys(variables).forEach((key) => {
          let newKey = '';
          for (let i = 0; i < key.length; i++) {
            const nextChar = (() => {
              if (['-', '_'].includes(key[i])) {
                return '';
              }
              if (['-', '_'].includes(key[i - 1])) {
                return key[i].toUpperCase();
              }
              return key[i];
            })();

            newKey += nextChar;
          }

          vars[newKey] = getVariable(this.component, key);
        });
        return vars;
      }
      return {};
    },

    variant() {
      return useVariant(this.component);
    },

    groupedVariables(): {
      [key: string]: Array<{ [key: string]: string | number | null }>;
    } {
      const pattern = /(\w+)_(\d+)_([\w\s]+)-\w+/;
      const grouped: {
        [key: string]: Array<{ [key: string]: string | number | null }>;
      } = {};
      const variables = this.component.variables;

      Object.keys(variables).forEach((key) => {
        const match = key.match(pattern);
        if (match) {
          const [, prefix, indexStr, name] = match;
          const index = parseInt(indexStr, 10) - 1;
          if (!grouped[prefix]) {
            grouped[prefix] = [];
          }
          if (!grouped[prefix][index]) {
            grouped[prefix][index] = {};
          }

          const variableValue = getVariable(this.component, key);
          if (variableValue !== null && variableValue !== '') {
            grouped[prefix][index][name] = variableValue;
          }
        }
      });
      Object.keys(grouped).forEach((prefix) => {
        grouped[prefix] = grouped[prefix].filter((item) => item && Object.keys(item).length > 0);
      });
      return grouped;
    },

    colors() {
      const websiteStore = useWebsiteStore();
      return websiteStore.colors;
    },
  },

  methods: {
    /**
     * @deprecated please use parseFormV2 function as it uses directly form data. You need to pass data of your variable.
     * @param key
     */
    parseForm(key: string) {
      try {
        const form = getVariable(this.component, key) as string;
        const parsedForm = JSON.parse(form);
        if (form && Object.keys(parsedForm).length) {
          return parsedForm;
        }
      } catch (e) {}

      return null;
    },

    /**
     * @description please pass your form data
     * @param formVariableValue
     */
    parseFormV2(formVariableValue: string) {
      try {
        const parsedForm = JSON.parse(formVariableValue);
        if (formVariableValue && parsedForm && Object.keys(parsedForm).length) {
          return parsedForm;
        }
      } catch (e) {}

      return null;
    },
  },
});
